import en from "vee-validate/dist/locale/en";
import w2h_en from '../../locales/en.json';

import es from "vee-validate/dist/locale/es";
import w2h_es from '../../locales/es.json';

import ko from 'vee-validate/dist/locale/ko';
import w2h_ko from '../../locales/ko.json';

import ru from 'vee-validate/dist/locale/ru';
import w2h_ru from '../../locales/ru.json';

import zh from 'vee-validate/dist/locale/zh_CN';
import w2h_zh from '../../locales/zh.json';

import vi from 'vee-validate/dist/locale/vi';
import w2h_vi from '../../locales/vi.json';

import pt from 'vee-validate/dist/locale/pt_PT';
import w2h_pt from '../../locales/pt.json';

import w2h_ht from '../../locales/ht.json';

// vee-validate ships no Haitian Creole locale, so these messages are built from templates in
// locales/ht.json (veeValidate.messages) instead of imported from the package like the others
// above.
const htMessages = w2h_ht.veeValidate.messages;
const RULES_WITH_CUSTOM_INTERPOLATION = ['after', 'before', 'decimal', 'length', 'lengthRange', 'orEqualText'];

function interpolateHtTemplate(template, field, params = []) {
  let result = template.replace(/\{field\}/g, field);
  params.forEach((value, index) => {
    result = result.replace(new RegExp(`\\{${index}\\}`, 'g'), value);
  });
  return result;
}

const ht = {
  name: 'ht',
  messages: {
    ...Object.fromEntries(
      Object.keys(htMessages)
        .filter((rule) => !RULES_WITH_CUSTOM_INTERPOLATION.includes(rule))
        .map((rule) => [rule, (field, params) => interpolateHtTemplate(htMessages[rule], field, params)])
    ),
    after: (field, [target, orEqual]) => interpolateHtTemplate(htMessages.after, field, [target])
      .replace('{orEqual}', orEqual ? htMessages.orEqualText : ''),
    before: (field, [target, orEqual]) => interpolateHtTemplate(htMessages.before, field, [target])
      .replace('{orEqual}', orEqual ? htMessages.orEqualText : ''),
    decimal: (field, params = []) => {
      const decimals = params[0];
      const decimalsSuffix = decimals && decimals !== '*' ? ` ${decimals}` : '';
      return interpolateHtTemplate(htMessages.decimal, field).replace('{decimalsSuffix}', decimalsSuffix);
    },
    length: (field, [length, max]) => interpolateHtTemplate(
      max ? htMessages.lengthRange : htMessages.length,
      field,
      max ? [length, max] : [length]
    ),
  },
  attributes: {}
};

export default {
  events: 'blur',
  dictionary: {
    en: {
      messages: {
        ...en.messages,
        // change required error message from awkward 'The ${field} field is required'
        required: (field) => `${field.replace(/^\w/, c => c.toUpperCase())} is required`,
        email: (field) => `${field.replace(/^\w/, c => c.toUpperCase())} must be a valid email address`,
        regex: (field) => `${field.replace(/^\w/, c => c.toUpperCase())} format is invalid`,
      },
      // attributes: ourEnglish.foo,
      attributes: w2h_en.veeValidate
    },
    es: {
      messages: es.messages,
      attributes: w2h_es.veeValidate
    },
    ko: {
      messages: ko.messages,
      attributes: w2h_ko.veeValidate
    },
    ru: {
      messages: ru.messages,
      attributes: w2h_ru.veeValidate
    },
    zh: {
      messages: zh.messages,
      attributes: w2h_zh.veeValidate
    },
    vi: {
      messages: vi.messages,
      attributes: w2h_vi.veeValidate
    },
    pt: {
      messages: pt.messages,
      attributes: w2h_pt.veeValidate
    },
    ht: {
      messages: ht.messages,
      attributes: w2h_ht.veeValidate
    }
  }
}